import React from 'react'
import {Box, Flex, Text, useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui'
import {FormattedMessage} from 'react-intl'
import {AlertTriangleIcon} from '../../../components/icons'

const NoExactMatch = () => {
    const styles = useMultiStyleConfig('Refinements')

    return (
        <Box {...styles.nrContainer}>
            <Flex align="center" gap={2}>
                <AlertTriangleIcon />
                <Text {...styles.nrText}>
                    <FormattedMessage
                        id="filters.no_exact_match.title"
                        defaultMessage="No exact matches"
                    />
                </Text>
            </Flex>
            <Text {...styles.nrDescription} marginTop={3}>
                <FormattedMessage
                    id="filters.no_exact_match.description"
                    defaultMessage="Try changing or removing some of your filters or adjusting your search area."
                />
            </Text>
        </Box>
    )
}

export default NoExactMatch
